import { render, staticRenderFns } from "./PagamentoRemessa.vue?vue&type=template&id=38a26af1"
import script from "./PagamentoRemessa.vue?vue&type=script&lang=js"
export * from "./PagamentoRemessa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports